import MapsService from "@churchofjesuschrist/maps-service";
import { configureMapsService } from "./maps-service-config";

export const geolocate = async () => {
  // Keep MapsService configured even when using cached location,
  // since callers may invoke additional MapsService methods afterwards.
  const mapsServiceConfigured = configureMapsService();

  if (sessionStorage.getItem("general-location")) {
    const json = sessionStorage.getItem("general-location");
    return JSON.parse(json);
  }

  if (!mapsServiceConfigured) {
    return null;
  }

  try {
    const result = await MapsService.geocodeIpAddress();
    const location = result?.[0] || null;
    if (location) {
      sessionStorage.setItem("general-location", JSON.stringify(location));
    }
    return location;
  } catch (error) {
    return null;
  }
};
